export enum DateFormat {
	'YYYY-MM-DD' = 'YYYY-MM-DD',
	'MM/DD/YYYY' = 'MM/DD/YYYY',
}
